<div class="modal-header py-2">
  <button type="button" class="close pull-right py-1" aria-label="Close" (click)="modalRef.hide();"
    style="margin-top: 0px;">
    <i class="fas fa-times"></i>
  </button>
  <span class="modal-title w-100" id="myModalLabel" style="font-weight: normal;font-size: 1.3rem !important;">Content
    Updates</span>
</div>
<div class="modal-body" style="background: #ffffff;">

  
  <div class="accordion-wrapper">
    <mdb-accordion [multiple]="false" class="content_updates_accordion">
      <mdb-accordion-item *ngFor="let item of accordionItems; let i = index" [collapsed]="i !== 0">
        <mdb-accordion-item-head>
          <h5>{{item.title}}</h5>
        </mdb-accordion-item-head>
        <mdb-accordion-item-body>
          <table class="table table-bordered content_updates_table mb-0 border-0" >
            <tbody>
              <tr *ngFor="let subject of item.subjects">
                <td width="20%" [ngClass]="subject.txt_content?.length > 0 ? 'p-2' : ''">{{subject.txt_description}}</td>
                <td width="40%">
                  <ng-container *ngFor="let txt_content of subject.txt_content">
                    <a href="{{txt_content.txt_pdf_url}}" target="_blank"
                      class="m-0 font_size px-2 my-2 mx-2 btn-deep-purple btn-sm btn custom-topic-btn"
                      *ngIf="txt_content.txt_content_type == 'pdf' && txt_content.txt_pdf_url?.trim()">
                      <i class="fas fa-download"></i> {{txt_content.txt_topic}}
                    </a>
                    <span class="blinking" *ngIf="txt_content.is_new == 1  && txt_content.txt_content_type == 'pdf' && txt_content.txt_pdf_url?.trim()">New</span>
                  </ng-container>
                </td>
                <td width="40%">
                  <ng-container *ngFor="let txt_content of subject.txt_content">
                    <a (click)="getVideoUrl(txt_content.txt_youtube_url, txt_content.txt_topic); audModal1.show()"
                      class="m-0 font_size px-2 my-2 mx-2 btn_miles_secondary btn-sm btn custom-topic-btn"
                      style="background-color: #E63946 !important; box-shadow: none;"
                      *ngIf="txt_content.txt_content_type == 'mp4'">
                      <i class="fas fa-play"></i> {{txt_content.txt_topic}}
                    </a>
                    <span class="blinking" *ngIf="txt_content.is_new == 1 && txt_content.txt_content_type == 'mp4'">New</span>
                  </ng-container>
                </td>
              </tr>
            </tbody>
          </table>
        </mdb-accordion-item-body>
      </mdb-accordion-item>
    </mdb-accordion>
  </div>
  

</div>

<!-- AUD Video Modal -->
<div mdbModal #audModal1="mdbModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myfarModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header py-1">
        <button type="button" class="close pull-right" aria-label="Close" (click)="audModal1.hide()">
          <i class="fa fa-times" aria-hidden="true"></i>
        </button>
        <h4 class="modal-title w-100" id="myModalLabel" style="font-weight: normal; font-size: 1.3rem !important;">{{txt_topic}}</h4>
      </div>
      <div class="modal-body">
        <iframe *ngIf="trustedUrl" width="100%" height="415" [src]="trustedUrl" title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen></iframe>
      </div>
    </div>
  </div>
</div>

<div mdbModal #audModal2="mdbModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myfarModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header py-1">
        <button type="button" class="close pull-right" aria-label="Close" (click)="audModal2.hide()">
          <i class="fa fa-times" aria-hidden="true"></i>
        </button>
        <h4 class="modal-title w-100" id="myModalLabel" style="font-weight: normal; font-size: 1.3rem !important;">AUD 6.4 Audit of Group FS (PCAOB AS 1206)</h4>
      </div>
      <div class="modal-body">
        <iframe width="100%" height="415" src="https://www.youtube.com/embed/HPWumZEm6Us" title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen></iframe>
      </div>
    </div>
  </div>
</div>

<div mdbModal #audModal3="mdbModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myfarModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header py-1">
        <button type="button" class="close pull-right" aria-label="Close" (click)="audModal3.hide()">
          <i class="fa fa-times" aria-hidden="true"></i>
        </button>
        <h4 class="modal-title w-100" id="myModalLabel" style="font-weight: normal; font-size: 1.3rem !important;">AUD 2.4 Audit Supervision (PCAOB AS 1201)</h4>
      </div>
      <div class="modal-body">
        <iframe width="100%" height="415" src="https://www.youtube.com/embed/dNa_O-dJhuE" title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen></iframe>
      </div>
    </div>
  </div>
</div>

<div mdbModal #audModal4="mdbModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myfarModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header py-1">
        <button type="button" class="close pull-right" aria-label="Close" (click)="audModal4.hide()">
          <i class="fa fa-times" aria-hidden="true"></i>
        </button>
        <h4 class="modal-title w-100" id="myModalLabel" style="font-weight: normal; font-size: 1.3rem !important;">AUD 1.3 Content Update (PCAOB AS 1000)</h4>
      </div>
      <div class="modal-body">
        <iframe width="100%" height="415" src="https://www.youtube.com/embed/mlUzHEUh68c" title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen></iframe>
      </div>
    </div>
  </div>
</div>

<!-- FAR Video Modal -->
<div mdbModal #farModal1="mdbModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myfarModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header py-1">
        <button type="button" class="close pull-right" aria-label="Close" (click)="farModal1.hide()">
          <i class="fa fa-times" aria-hidden="true"></i>
        </button>
        <h4 class="modal-title w-100" id="myModalLabel" style="font-weight: normal; font-size: 1.3rem !important;">FAR Q1 2025 Content update overview</h4>
      </div>
      <div class="modal-body">
        <iframe width="100%" height="415" src="https://www.youtube.com/embed/yYS0fDYcfyw" title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen></iframe>
      </div>
    </div>
  </div>
</div>

<div mdbModal #farModal2="mdbModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myfarModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header py-1">
        <button type="button" class="close pull-right" aria-label="Close" (click)="farModal2.hide()">
          <i class="fa fa-times" aria-hidden="true"></i>
        </button>
        <h4 class="modal-title w-100" id="myModalLabel" style="font-weight: normal; font-size: 1.3rem !important;">Enhanced disclosures for Income Tax Expense</h4>
      </div>
      <div class="modal-body">
        <iframe width="100%" height="415" src="https://www.youtube.com/embed/V7HqA9D2apA" title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen></iframe>
      </div>
    </div>
  </div>
</div>

<div mdbModal #farModal3="mdbModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myfarModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header py-1">
        <button type="button" class="close pull-right" aria-label="Close" (click)="farModal3.hide()">
          <i class="fa fa-times" aria-hidden="true"></i>
        </button>
        <h4 class="modal-title w-100" id="myModalLabel" style="font-weight: normal; font-size: 1.3rem !important;">Accounting for crypto assets</h4>
      </div>
      <div class="modal-body">
        <iframe width="100%" height="415" src="https://www.youtube.com/embed/u8eCZDbq1Fo" title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen></iframe>
      </div>
    </div>
  </div>
</div>

<div mdbModal #farModal4="mdbModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myfarModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header py-1">
        <button type="button" class="close pull-right" aria-label="Close" (click)="farModal4.hide()">
          <i class="fa fa-times" aria-hidden="true"></i>
        </button>
        <h4 class="modal-title w-100" id="myModalLabel" style="font-weight: normal; font-size: 1.3rem !important;">Accounting of credit losses under CECL model</h4>
      </div>
      <div class="modal-body">
        <iframe width="100%" height="415" src="https://www.youtube.com/embed/eI86NN8MNHY" title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen></iframe>
      </div>
    </div>
  </div>
</div>